<div class="question-container" [ngClass]="questionClass">
    <div class="row-one">
        <div class="column-one" [class.read-only-column-one]="readOnly">
            <div class="acs-code" *ngIf="showAcsCode">
                <span *ngIf="acsCode" [title]="acsCode?.AscCodeDescription">
                    {{acsCode?.AcsCode}}  
                    <!-- <i class="fa fa-times dw-red" title="Missed ACS Code" [hidden]="!isMissedCode"></i> -->
                    <img [src]="missingAcsCodeImageUrl" *ngIf="isMissedCode" class="missed-acs-code" title="Missed ACS Code"/>
                </span>
            </div>
            <div class="question-result" *ngIf="showAcsCode">
                <dw-radio-lookup *ngIf="!readOnly" [(ngModel)]="result.QuestionOutcomeId" (ngModelChange)="onChange()"
                    [lookupId]="outcomeLookupId">
                </dw-radio-lookup>
                <div class="question-result-readonly" *ngIf="readOnly && result?.QuestionOutcomeId">
                    <dw-lookup-readonly [lookupId]="outcomeLookupId" [(ngModel)]="result.QuestionOutcomeId" useTransitions="false">
                    </dw-lookup-readonly>
                </div>
                <a class="dw-link dw-red " *ngIf="result.QuestionOutcomeId && !readOnly" (click)="clearOutcome(result)"><i class="fa fa-times"></i> Clear</a>
            </div>
            <div class="question-result" *ngIf="!showAcsCode">
                <input type="checkbox" [(ngModel)]="checkedValue" (ngModelChange)="updateCheckedValue($event)" value="1" [disabled]="readOnly">
            </div>
        </div>
        <div class="column-two" [class.read-only-column-two]="readOnly">
            <div class="question" [ngClass]="{ 'question-acs': this.showAcsCode, 'question-readonly': readOnly }" *ngIf="showQuestion || showQuestionDescription">
                <dw-html-view [ngModel]="question?.QuestionHtml" *ngIf="showQuestion"></dw-html-view>
                <div class="acs-description" *ngIf="showQuestionDescription">ACS: {{acsCode?.AscCodeDescription}}</div>
            </div>
            <div class="question-notes" *ngIf="showNotes && (!readOnly || showReadOnlyNotes)">
                <input type="text" [(ngModel)]="result.Notes" (ngModelChange)="onChange()" placeholder="Notes"
                    [readOnly]="readOnly"
                    class="form-control hide-print" [class.readonly-notes]="readOnly">
                <input type="text" [(ngModel)]="result.Notes" (ngModelChange)="onChange()"
                    [readOnly]="readOnly"
                    class="form-control show-print" [class.readonly-notes]="readOnly">
            </div>
        </div>
    </div>
</div>
